/*
 * @Author: your name
 * @Date: 2020-09-08 16:58:30
 * @LastEditTime: 2022-12-01 10:36:41
 * @LastEditors: error: git config user.name && git config user.email & please set dead value or install git
 * @Description: In User Settings Edit
 * @FilePath: /frontend-user/src/main.js
 */
import Vue from 'vue'
import 'amfe-flexible'
import 'intersection-observer'

import App from './App.vue'
import router from './router'
import store from './store'
import _ from 'lodash'
import componentLoader from '@/utils/componentLoader'

import '@/icons' // icon
import './style/index.sass' // global css
import './styles/ui-imports' // UI library styles
import 'flag-icons/css/flag-icons.min.css' // flag icons for language/currency selectors
import Fetch from 'utils/request'
import './plugins'
import 'components/global'

// 核心依赖 - 同步加载
import VueGtag from 'vue-gtag'
import VueMeta from 'vue-meta'
import openreplayTracker from 'utils/openreplay'
import { analyticsAllowedAt } from '@/utils/menu/previewMenu'
import { gtagRouterOptions, keepShareCodesOutOfGtag } from '@/utils/menu/shareCodes'
import 'utils/umami' // 注入 Umami 统计脚本（自动采集全站 pageview；未配置环境变量时为 no-op）

// 延迟加载的非关键依赖
const loadNonCriticalDeps = () => {
  return Promise.all([
    import('muse-ui/lib/Helpers'),
    import('@vant/touch-emulator'),
    import('utils/jsErrorCollection').then(({ jsErrorCollection }) => {
      import('utils/openreplay').then(({ openreplayHandlerError }) => {
        jsErrorCollection({ runtimeError: true, rejectError: true, consoleError: false }, (errLog) => {
          openreplayHandlerError(errLog)
        })
      })
    })
  ])
}

// Muse UI 组件 - 延迟加载
const loadMuseUIComponents = () => {
  const promise = Promise.all([
    import('muse-ui').then(({ AppBar, Select, TextField, Dialog, Progress, Icon, ExpansionPanel }) => {
      Vue.use(AppBar)
      Vue.use(Select)
      Vue.use(TextField)
      Vue.use(Dialog)
      Vue.use(Progress)
      Vue.use(Icon)
      Vue.use(ExpansionPanel)
    }),
    import('muse-ui-loading').then(Loading => {
      Vue.use(Loading)
    })
  ]).then(() => {
    // 标记 Muse UI 组件已加载
    componentLoader.loadedComponents.add('muse-ui')
    console.log('Muse UI components loaded')
  })

  // 注册加载承诺
  componentLoader.registerLoadingPromise('muse-ui', promise)
  return promise
}

// Element UI 组件 - 延迟加载
const loadElementUIComponents = () => {
  const promise = import('element-ui').then(({ Form, FormItem, Input, Checkbox, Button, CheckboxGroup, Radio, RadioGroup }) => {
    Vue.use(Form)
    Vue.use(FormItem)
    Vue.use(Input)
    Vue.use(Checkbox)
    Vue.use(Button)
    Vue.use(CheckboxGroup)
    Vue.use(Radio)
    Vue.use(RadioGroup)

    // 标记 Element UI 组件已加载
    componentLoader.loadedComponents.add('element-ui')
    console.log('Element UI components loaded')
  })

  // 注册加载承诺
  componentLoader.registerLoadingPromise('element-ui', promise)
  return promise
}

// G-YKS8T8YLBG is test google analytics
// 多版本菜单 B6（U-B6-3，owner D93）：菜单预览页（地址里有 previewMenu 键）**不安装** vue-gtag —— 它的 enabled:false 只是 optOut，
// 脚本照样加载、路由照样追踪 page_view。不装时 this.$gtag 是 undefined，各使用点都判了空（sales 页那处本批补上）
// 多版本菜单 N35（review R4B5-4）：点单链接码不送给 Google Analytics —— page_view 的 page_location、之后自定义事件按页面记的地址
// 都换成去掉两个分享码的当前地址（utils/menu/shareCodes.js；地址里没有码时 page_view 与不配模板时逐字节相同）
// N35-B2 第 5 轮：选项整份来自 gtagRouterOptions（测试照同一份装）—— 多排除起点 `/`：扫码落地时第一个导航被守卫重定向，
// 服务器构建的 vue-router 3.3.4 在那一下就算 ready，vue-gtag 会多记一条 `/` 的 page_view
if (analyticsAllowedAt(window.location.search)) {
  Vue.use(VueGtag, gtagRouterOptions(process.env.VUE_APP_ENV === 'production' ? 'G-69SFYV49LT' : 'G-YKS8T8YLBG'), router)
  keepShareCodesOutOfGtag(router)
}

// openreplay tracker
Vue.use(openreplayTracker)

// meta for seo
Vue.use(VueMeta)

Vue.prototype._ = _
Vue.prototype.$http = Fetch

// Global locale mixin — provides reactive $lang, $currencyCode, $currencySymbol, $symbolPosition
// to ALL components. This eliminates the need to add currentLanguage/currentCurrency mapState
// to every individual component for i18n/currency reactivity.
// 全局语言/货币 mixin — 为所有组件提供响应式的 $lang, $currencyCode, $currencySymbol, $symbolPosition。
// 这样就不需要在每个组件中单独添加 currentLanguage/currentCurrency mapState 来实现响应式。
Vue.mixin({
  computed: {
    $lang() {
      return this.$store?.state?.language?.currentLanguage || 'en'
    },
    $currencyCode() {
      return this.$store?.state?.currencySettings?.currentCurrency || 'AUD'
    },
  },
})

Vue.config.productionTip = false
const colorDefault = {
  menu_primary_background_colour: '#14C4BC',
  menu_header_background_colour: '#14C4BC',
  menu_header_colour: '#fff',
  menu_primary_text_colour: '#000',
}

Object.keys(colorDefault).forEach(item => {
  const res = localStorage.getItem(item)
  if (res) {
    document.body.style.setProperty('--' + item.replace(/_/g, '-'), res)
  }
})

// 判断是否需要立即加载某些组件
const shouldLoadUILibsFirst = () => {
  const path = window.location.pathname
  return path.includes('payment') ||
         path.includes('pay') ||
         path.includes('checkout') ||
         path.includes('cart')
}

// 创建并挂载应用的函数
const createAndMountApp = () => {
  const app = new Vue({
    router,
    store,
    render: h => h(App)
  })
  app.$mount('#app')
}

// 如果是关键页面，先加载必要组件再创建应用
if (shouldLoadUILibsFirst()) {
  Promise.all([
    loadMuseUIComponents(),
    loadElementUIComponents()
  ]).then(() => {
    createAndMountApp()
  }).catch(error => {
    console.error('Failed to load UI components:', error)
    createAndMountApp() // 失败也要创建应用
  })
} else {
  // 非关键页面直接创建应用
  createAndMountApp()
}

// 检查是否需要立即加载某些组件
const shouldLoadUILibsImmediately = () => {
  const path = window.location.pathname
  // 这些页面可能使用 Muse UI 或 Element UI 组件
  return path.includes('payment') ||
         path.includes('checkout') ||
         path.includes('login') ||
         path.includes('register') ||
         path.includes('form') ||
         path.includes('contact-details') ||
         path.includes('contact_details')
}

// 延迟加载非关键依赖以提升初始加载性能
const loadDelay = shouldLoadUILibsImmediately() ? 0 : 1000

setTimeout(async () => {
  try {
    // 并行加载所有非关键依赖
    await Promise.all([
      loadNonCriticalDeps(),
      loadMuseUIComponents(),
      loadElementUIComponents()
    ])

    console.log('non critical dependencies load complete')

    // 初始化性能监控
    // 多版本菜单 B6（U-B6-2 review 第 2 轮 G10）：菜单预览页（地址里有 previewMenu 键）不启动 —— 它把整个地址（带码）放进上报的数据里；
    // 与上面 vue-gtag / OpenReplay / Umami 同一个判据（utils/menu/previewMenu.js analyticsAllowedAt）
    if (process.env.VUE_APP_ENV === 'production' && analyticsAllowedAt(window.location.search)) {
      import('./utils/performance').then(({ initPerformanceMonitoring }) => {
        initPerformanceMonitoring(router)
      })
    }
  } catch (error) {
    console.error('non critical dependencies load error:', error)
  }
}, loadDelay)

// 导出加载函数以供其他模块使用
export { loadMuseUIComponents, loadElementUIComponents }
